import { createIcon } from '../icon'
import ArrowUpDownIcon from '@/components/atoms/svg/ArrowUpDown'

export const ArrowUpDownIconDefault = createIcon(ArrowUpDownIcon)
